// extracted by mini-css-extract-plugin
export default {"Bar":"styles_Bar__q0gkl","FillBar":"styles_FillBar__VIwVk"};